// serve members bundles from a static CDN
// instead of the production `viewer-apps.parastorage.com/piler-router/{jsx,css,sdk}` URLs
//
// Keyed by builder type (e.g. `membersAreaCoreWidgets.SettingsPage`). Each of the three load sites
// (jsx: builder component loader, sdk: componentSdksManager, css: componentManifestCss) consults this
// map before fetching; a missing type/artifact means "no override — use the original URL".
//
// The `?bundler=piler-router` marker is intentional: several code paths detect a
// "piler component" via `componentUrl.includes('piler-router')`
// (SSR isolate deps in builderComponentDeps, SSR sdk UMD deps in ssrBuilderComponentSdkLoader).
// Our rehosted bundles ARE piler output, but live under a `static.parastorage.com` path without that substring,
// so without the marker the SSR isolate skips the builder runtime deps
// (@wix/builder-velo, @wix/builder-state, ...)
// and the module fails to link — the component renders on the client but not in SSR.
// The static CDN serves the file unchanged with the extra query param. Encoding the "treat as a piler bundle"
// signal in the URL keeps the core `isPilerComponent`/`isPilerRouter` predicates
// (in builderComponentDeps, ssrBuilderComponentSdkLoader, builderComponentsData, createBuilderComponentResolver)
// untouched.

type BuilderArtifact = 'jsx' | 'sdk' | 'css'

const PILER_ROUTER_MARKER = '?bundler=piler-router'
const DUMP_VERSION = '12.453.0'
const DUMP_BASE = `https://static.parastorage.com/services/piler-bob-legacy-members/${DUMP_VERSION}`
const MY_ACCOUNT_BASE = `${DUMP_BASE}/MyAccount`
const MEMBERS_AREA_BASE = `${DUMP_BASE}/MembersArea`

const STATIC_BUNDLE_OVERRIDES: Record<string, Partial<Record<BuilderArtifact, string>>> = {
	'membersAreaCoreWidgets.SettingsPage': {
		jsx: `${MY_ACCOUNT_BASE}/MyAccount.js${PILER_ROUTER_MARKER}`,
		sdk: `${MY_ACCOUNT_BASE}/sdkFactory.js${PILER_ROUTER_MARKER}`,
		css: `${MY_ACCOUNT_BASE}/MyAccount.css${PILER_ROUTER_MARKER}`,
	},
	'membersAreaCoreWidgets.Widget1': {
		jsx: `${MEMBERS_AREA_BASE}/MembersArea.js${PILER_ROUTER_MARKER}`,
		sdk: `${MEMBERS_AREA_BASE}/sdkFactory.js${PILER_ROUTER_MARKER}`,
		css: `${MEMBERS_AREA_BASE}/MembersArea.css${PILER_ROUTER_MARKER}`,
	},
}

export const getStaticBundleOverrideUrl = (
	builderType: string | undefined,
	artifact: BuilderArtifact,
	originalUrl: string
): string => (builderType && STATIC_BUNDLE_OVERRIDES[builderType]?.[artifact]) || originalUrl
